"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defineAppConfig_1 = require("../defineAppConfig");
exports.default = (0, defineAppConfig_1.defineAppConfig)({
    appName: '絶叫界隈',
    organizationId: 'ZAlZ33bzmjy6b1UWJQKP',
    applicationKey: 'zekkyokaiwai',
    applicationType: 'standalone',
    artistId: 'RDnzpvKohOZl9Ckx9tXWovQmMLq2',
    theme: { dark: true },
    deeplinkUrl: 'https://fujiq-zekkyokaiwai.jp',
    helpUrl: 'https://help.utoniq.com/ja/collections/2299305',
    deeplinkStg: 'zekkyokaiwai-stg.netlify.app',
    custom: {
        modules: {
            membership: true,
            thread: true,
            gacha: true,
            liveStream: true,
            item: true,
            store: true,
            campaign: true,
            mission: true,
            resale: true,
            preSale: true,
            event: true,
            cart: true,
            pickup: true,
            eprint: true,
            konbiniPayment: true,
        },
        tutorials: [],
        globalTabs: [],
        artistTabs: ['home', 'ownedItems', 'myProfile'],
    },
});
